import styled from 'styled-components';
import { Flex } from 'rebass/styled-components';
import { mediaQueries, variables } from 'shared/styles';

export default styled(Flex)`
  padding: 0;
  margin: 0 auto;
  max-width: ${variables.maxWidthLarge}px;
  width: ${variables.maxWidthLarge}px;
  align-items: center;
  justify-content: center;
  @media ${mediaQueries.largeDesktop} {
    max-width: 100%;
    width: ${variables.maxWidthMed}px;
  }
`;
